import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '../services';

@Pipe({ name: 'formatCurrency', pure: true, standalone: true })
export class FormatCurrencyPipe implements PipeTransform {
    constructor(private currencyService: CurrencyService) {}

    transform(value: number | string | null | undefined): string {
        return this.currencyService.formatCurrency(value);
    }
}
